<script>
import PageLayout from "@/components/PageLayout";
import { dictionarySideBar } from "./dictionarySidebar";

export default {
  name: "DictionaryIndex",
  components: { PageLayout },
  data: () => ({
    sideBarLinks: dictionarySideBar,
  }),
};
</script>

<template>
  <div>
    <PageLayout title="Аналитика" :sidebar-links="sideBarLinks" />
  </div>
</template>

<style scoped lang="scss"></style>
